module.exports = __webpack_public_path__ + "img/pledge.fd1bf510.png";